export const UserRole = {
  Admin: 'ROL_SUPER',
  Editor: 'ROL_USER',
};

/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'en';
export const localeOptions = [{ id: 'es', name: 'Español', direction: 'ltr' }];

export const firebaseConfig = {
  apiKey: 'AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg',
  authDomain: 'gogo-react-login.firebaseapp.com',
  databaseURL: 'https://gogo-react-login.firebaseio.com',
  projectId: 'gogo-react-login',
  storageBucket: 'gogo-react-login.appspot.com',
  messagingSenderId: '216495999563',
};

export const adminRoot = '/portal/app';
export const buyUrl = 'https://1.envato.market/k4z0';
export const searchPath = `${adminRoot}/#`;
export const servicePath = 'https://api.coloredstrategies.com';

export const currentUser = {
  id: 1,
  title: 'Sarah Kortney',
  img: '/assets/img/profiles/l-1.jpg',
  date: 'Last seen today 15:24',
  role: UserRole.Admin,
};

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = true;
export const defaultColor = 'light.blueolympic';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
];
// url del front de la aplicacion
// export const urlFront = "http://localhost:3000";
// export const urlFront = "http://20.124.173.250";
// export const urlFront = "https://agendamientooia.efigas.com.co";
// export const urlFront = "https://portaltecnico.efigas.com.co";
export const urlFront = 'https://portal-tecnico.efigas.com.co';

// perfil de empresa OIA
export const perfilEmpresa = 53;
// perfil de empresa OIA
export const adminOIA = [54, 63];

// export const urlBase = "http://localh/efigas.z13.web.core.windows.netost:8081/api/v1";
// export const urlBase = "http://20.241.217.87:8081/api/v1";
// export const urlBase = 'http://localhost:8081/api/v1';
export const urlBase = "https://portal-tecnico.efigas.com.co/api/v1";
// export const urlBase = "https://portaltecnico-qt.efigas.com.co/api/v1";

export const maxRows = 10000;
